import { NgModule } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { LayoutNoHeaderComponent } from '../common/components/layout-no-header/layout-no-header.component';
import { UserAuthGuard } from '../user/guards/user-auth-guard';
import { PermissionGuard } from '../../core/guards/permission.guard';
import { CollectSuccessComponent } from './pages/collect-success/collect-success.component';
import { CollectComponent } from './pages/collect/collect.component';
import { QuickPayComponent } from './pages/quick-pay/quick-pay.component';


@NgModule({
  providers: [
    provideRouter([
      {
        path: 'payment',
        component: LayoutNoHeaderComponent,
        canActivate: [UserAuthGuard],
        children: [
          {
            path: 'collect',
            component: CollectComponent,
            canActivate: [PermissionGuard],
            data: { permissions: 'TRANSACTION_SALE' },
          },
          {
            // The profile's enableQuickPay is enforced by FTE (403); the header hides the button.
            path: 'quick-pay',
            component: QuickPayComponent,
            canActivate: [PermissionGuard],
            data: { permissions: 'TRANSACTION_SALE' },
          },
          {
            path: 'collect-success',
            component: CollectSuccessComponent,
          }
        ]
      },
    ], withComponentInputBinding()),
  ]
})
export class PaymentRoutingModule { }
